export enum YesNoRadioGroup {
  EMPTY = 0,
  NO = 1,
  YES = 2
}
